// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4ab6c6c0","239":"8b8c3c17","455":"c2ebc6e4","488":"dc03c67e"}[chunkId] + ".chunk.js";
};